module.exports = __webpack_public_path__ + "media/country_flags/ie-52038120.png";